import { render, staticRenderFns } from "./productTeamInfo.vue?vue&type=template&id=786d8074&scoped=true"
import script from "./productTeamInfo.vue?vue&type=script&lang=js"
export * from "./productTeamInfo.vue?vue&type=script&lang=js"
import style0 from "./productTeamInfo.vue?vue&type=style&index=0&id=786d8074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d8074",
  null
  
)

export default component.exports